export class NomeRubrica {
  constructor ({completo, abreviado}) {
    this.completo = completo
    this.abreviado = abreviado
  }
}
